export default "__VITE_ASSET__Dy1NqoDO__"